import { setAdminStyleNonce } from '@realrain/ui/admin';
import '@realrain/ui/admin.css';
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "@realrain/ui/styles.css";
import "./styles.css";
import "./admin-density.css";
import "./console-refinement.css";
import "./page-refinement.css";

setAdminStyleNonce(document.querySelector<HTMLMetaElement>('meta[name="admin-style-nonce"]')?.content);

createRoot(document.getElementById("root")!).render(
  <StrictMode><BrowserRouter><App /></BrowserRouter></StrictMode>,
);
